import { setCookie } from "../common/auth";
import { authCookie } from "../common/cookieOptions";
import http from "./constants/http";
import resources from "./constants/resources";

export const checkUidConfirm = async (body) => {
  const response = await http(resources.MEMBER).post(body);

  const { status } = response;
  const { Code, Data } = response.data;

  if (status === 200) {
    if (Code === "0000") {
      return response.data;
    } else if (Code === "9999") {
      return response.data;
    }
  } else {
    return console.log("정상적인 요청이 아닙니다. 나중에 다시 시도해주세요.");
  }
};

export const submitRegisterForm = async (body) => {
  const response = await http(resources.MEMBER).post(body);

  const { status } = response;
  const { Code, Data } = response.data;

  if (status === 200) {
    if (Code === "0000") {
      setCookie("token", Data.token, authCookie);
      return "Success";
    } else if (Code === "9999") {
      return Data.Msg;
    }
  } else {
    return console.log("정상적인 요청이 아닙니다. 나중에 다시 시도해주세요.");
  }
};
